export const REDUCE_BROKERCOMPANY_SETTINGS = 'REDUCE_BROKERCOMPANY_SETTINGS';
export const GET_BROKERCOMPANY_SETTINGS = 'GET_BROKERCOMPANY_SETTINGS';